import type { JSX, ReactNode } from "react";

/**
 * Light-only theme provider — placeholder for future dark mode.
 * Sets `data-theme="light"` on <html> so future tokens can scope.
 */
export function ThemeProvider({ children }: { children: ReactNode }): JSX.Element {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-theme", "light");
  }
  return <>{children}</>;
}
